import { debounce } from 'debounce'
import React, { useEffect, useCallback, useMemo, useRef, useState } from 'react'
import Ruler from './ruler'
import './editor.scss'
import { HorizontalBorder } from './horizontalBorder'
import { FabricCanvas } from '../components/Scen/FabricCanvas'
import { useDispatch, useSelector } from 'react-redux'
import { UploadButton } from './UploadButton'
import { DECREMENT_NO_OF_FABRIC_UNITS, INCREMENT_NO_OF_FABRIC_UNITS, UPDATE_DISPLAY_UNITS } from '../redux/reducers/settings'
import { roundOff } from '../utilities'
import { changePartLength } from '../redux/actions/parts'
import { useTranslation } from 'react-i18next'
import { UploadOverlay } from '../UploadOverlay'
import alertify from '../libs/alert'

import { ReactComponent as IconInfoBtn } from  "../images/Info_icn.svg"
import { ImageLibrary } from '../ImageLibrary/ImageLibrary'
import { ThirdPartyLibraryState } from '../ImageLibrary/types/ThirdPartyLibrary'
import { FabricLibrary } from '../FabricLibrary/SelectionGrid'
import { IFabricLibrary } from '../FabricLibrary/redux/reducer'
import { WizardScreenType, useFabricWizard } from './useFabricWizard'
import { setSpinner } from '../redux/actions/spinner'

type EditorProps = {
    fabricWidth: number,
    noOfParts: number,
    partSize: number,
    stepSize: number,
    activePart: any,
    maxLength: number,
    partId: string,
    partLength: number,
    rows?: number
    appVersion: string,
    onScenDimensionsUpdated: (dims:{width:number, height:number})=>void
}

export const Editor = (props: EditorProps) => {
    const { activePart, maxLength, fabricWidth, noOfParts, partSize, stepSize, partId, partLength = 0, rows = 1, onScenDimensionsUpdated } = props

    const [wizardScreen, setWizardScreen] = useState(undefined as undefined | WizardScreenType)
    const scenRef = useRef(undefined as any);
    const [scenDimensions, setScenDimensions] = useState({ width: 0, height: 0 });
    const [prodPosition, setProdPosition] = useState(0);
    const fabricUnit = useSelector((state: any) => state.settings.unitType);
    const [currentLength, setCurrentLength] = useState(stepSize);
    const dispatch = useDispatch();
    const {t} = useTranslation();

    const { openForSelection, screenType } = useSelector((state: any) => state.thirdPartyLibrary) as ThirdPartyLibraryState
    const showFabricWizard = useSelector((state: any) => state.fbdata?.fabricWizard);
    const { displayFabricLibrary, tiles} = useSelector((state: any) => state.fabricLibrary) as IFabricLibrary

    const wizardConfig = useFabricWizard(screenType || wizardScreen);

    const appVersion = props.appVersion

    const sendToHost = useCallback((action, value=0) => {
        let url =
            window.location !== window.parent.location
                ? document.referrer
                : document.location.origin
    
        window.parent.postMessage(
            JSON.stringify({
                action,
                value
            }),
            url,
        )
      }, [window])

    useEffect(() => {
        if (window.parent) {
            sendToHost('SCROLL_TO_TOP');
//             var elem = document.getElementById("0"); // id of AddToCart button
//             var elem1 = document.getElementById("1"); // id of Sample1 (if it exists) button
//             var elem2 = document.getElementById("2"); // id of Sample2 (if it exists) button

//             if (elem2) {
//                 elem = elem2
//             } else if (elem1) {
//                 elem = elem1
//             }            

//             var ht = elem?.getBoundingClientRect();
            var ht = document.body.offsetHeight;
            if (ht) {
                //sendToHost('CALC_IFRAME_HEIGHT', ht.bottom);
                sendToHost('CALC_IFRAME_HEIGHT', ht);
            }
        }
    }, [wizardScreen])

    useEffect(() => {
        setCurrentLength(partLength)
    },[partLength])

    useEffect(() => {
        getFcSize();
        function getFcSize() {
            (debounce(() => {
                setScenDimensions({
                    width: scenRef.current?.offsetWidth,
                    height: scenRef.current?.offsetHeight,
                })
                onScenDimensionsUpdated({
                    width: scenRef.current?.offsetWidth,
                    height: scenRef.current?.offsetHeight,
                })
            }, 10))()
        };
        window.addEventListener("resize", getFcSize)
        window.addEventListener("orientationchange", getFcSize)
        return () => {
            window.removeEventListener("resize", getFcSize)
            window.removeEventListener("orientationchange", getFcSize)
        }
    }, []);

    const isScenWidthKnown = !!(scenDimensions.height && scenDimensions.width);

    return <div className='playground-container'><div className='editor-container'>
        <div className='horizontal-ruler-container'>
            {isScenWidthKnown ? <Ruler
                fabricWidth={fabricWidth}
                start={0}
                type={'HORIZONTAL'}
                partsCount={noOfParts}
                partSize={partSize}
                containerWidth={scenDimensions.width}
                containerHeight={scenDimensions.height}
            /> : null}
        </div>
        <div className='scrollable-container'>
        <div className='vertical-ruler-container ruler-markings'>
            {isScenWidthKnown ? <Ruler
                fabricWidth={fabricWidth}
                containerWidth={scenDimensions.width}
                containerHeight={scenDimensions.height}
                partsCount={noOfParts}
                start={prodPosition}
                stepSize={stepSize}
                    partSize={currentLength}
                type="VERTICAL"
            /> : null}
        </div>
        <div className="scen-container">
            <HorizontalBorder ref={scenRef} />
            {isScenWidthKnown ? <FabricCanvas containerWidth={scenDimensions.width}
                productWidth={fabricWidth}
                unit={fabricUnit}
                fabricSizeUnit={fabricUnit}
                activeUrl={(url) => {
                    //setCurFocusedImg(url) 
                }}
                loadImage={(isLoading) => {
                    //setLoading(isLoading)
                }}
                imageSelectionChange1={(wd, limits) => {
                    // setCurFocusedImgWidth(wd)
                    // limits && setCurFocusImgLimitsWidth(limits)
                }}
                imageSelectionChange2={(ht, limits) => {
                    // setCurFocusedImgHeight(ht)
                    // limits && setCurFocusImgLimitsHeight(limits)
                }}
                // activePart={parts}
                partLengthChanged={(length = 0, change = 0) => {
                    //TODO: fix this:
                    //const currentLength = change ? roundOff(partLength + (change * rows), 3) : roundOff(length, 3)
                    const currentSections = Math.ceil((length) / stepSize)
                    setTimeout(() => {
                        setCurrentLength(roundOff(length, 3));
                        if (change > 0) {
                            dispatch({ type: INCREMENT_NO_OF_FABRIC_UNITS, payload: currentSections })
                        } else if (change < 0) {
                            dispatch({ type: DECREMENT_NO_OF_FABRIC_UNITS, payload: currentSections })
                        }
                        // dispatch(changePartLength(activePart, length, maxLength, t, true))
                        dispatch({
                            type: UPDATE_DISPLAY_UNITS,
                            payload: {
                                currentLength: length
                            }
                        });
                    }, 10);
                }}
                toastify={(msg) => {
                    // notify(msg)
                }}
            /> : null}
            </div>
        </div>
    </div>
        <div className='upload-button-container'>
            <div className='upload-container-appVersion'>
                <button className='upload-container-appVersionBtn' 
                    onClick={() => {
                        alertify.alert(t("editor.alert_warning_title3"), "App version at: " + appVersion, "OK");
                    }}>
                    <IconInfoBtn style={{ width: 20, height: 20 }} />
                </button>
            </div>
            {/* <UploadButton fabricSize={scenDimensions} partId={partId} /> */}
        </div>
        <div>
            {
                wizardConfig && !wizardConfig.skipWizard ?
                    <div>
                        {wizardConfig.showFabricSelectorScreen ? <FabricLibrary tiles={tiles} showBackButton={wizardConfig?.showBackButton} wizardScreen={(screenType) => {
                            setWizardScreen(screenType || 'FabricSelector')
                        }} /> : null}
                        {wizardConfig.showTileSelectorScreen ? <ImageLibrary
                            wizardScreen={(screenType) => {
                                dispatch(setSpinner(false))
                                setWizardScreen(screenType || 'TilesSelector')
                            }}
                            showBackButton={wizardConfig?.showBackButton}
                            fabricSize={scenDimensions}
                            imageUploadInProgress={(progress) => { dispatch(setSpinner(progress))}}
                            onImageSelected={() => { }}
                            partId={partId} /> : null}
                    </div> :
                    <div>
        {openForSelection?<ImageLibrary
            showBackButton={wizardConfig?.showBackButton}
            fabricSize={scenDimensions}
            imageUploadInProgress={(progress) => { dispatch(setSpinner(progress))}}
            onImageSelected={() => { }}
            partId={partId}/>:null}
        {displayFabricLibrary?<FabricLibrary showBackButton={wizardConfig?.showBackButton} tiles={tiles}/>: null}    
                        {!showFabricWizard?<UploadOverlay fabricSize={scenDimensions} partId={partId} />:null}
                    </div>
            }
        </div>
    </div>
}
